import { Link } from "react-router";
import { ScreenHeader } from "../components/ScreenHeader";

export function NotFoundScreen() {
  return (
    <div>
      <ScreenHeader
        kicker="Not found"
        title="That page doesn't exist."
        sub="Your progress is safe."
      />
      <Link to="/hub" className="font-bold text-accent underline">
        Back to my steps
      </Link>
    </div>
  );
}
